import { useTranslation } from "react-i18next";

import { ColorPicker } from "@/content-hub/editor/color-presets/color-picker-loader";

import type { ButtonProps } from "./button";

type ButtonCustomStyleSettingsProps = {
  colorSet: ButtonProps["colorSet"];
  dataTestId?: string;
  onChange: (updates: Partial<ButtonProps["colorSet"]>) => void;
  onReset?: () => void;
};

export function ButtonCustomStyleSettings({
  colorSet,
  dataTestId = "button-custom-styles",
  onChange,
  onReset,
}: ButtonCustomStyleSettingsProps) {
  const { t } = useTranslation();

  return (
    <fieldset data-testid={dataTestId}>
      <legend className="mb-2 w-full">
        <div className="flex w-full items-center justify-between">
          <span className="text-xs font-medium text-gray-700">
            {t("preference-panel.custom-styles")}
          </span>
          {onReset ? (
            <button
              type="button"
              aria-label={t("preference-panel.reset")}
              className="border-none bg-transparent p-0 text-xs font-medium text-blue-500 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1"
              title={t("preference-panel.reset-custom-styles-tooltip")}
              onClick={onReset}
            >
              {t("preference-panel.reset")}
            </button>
          ) : null}
        </div>
      </legend>
      <div className="flex flex-row gap-x-2">
        <ColorPicker
          defaultValue={colorSet.background}
          title={t("preference-panel.color-labels.background")}
          onChange={(background: string) => onChange({ background })}
        />
        <ColorPicker
          defaultValue={colorSet.text}
          title={t("preference-panel.color-labels.font")}
          onChange={(text: string) => onChange({ text })}
        />
        <ColorPicker
          defaultValue={colorSet.border}
          title={t("preference-panel.color-labels.border")}
          onChange={(border: string) => onChange({ border })}
        />
      </div>
    </fieldset>
  );
}
